import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccountUiModule } from '@platform-frontend/account-ui';
import { MarketplaceProductModule } from '@platform-frontend/marketplace';
import {
  ButtonModule,
  CollapseModule,
  FileSelectModule,
  FormsModule,
  IconsModule,
  LinkModule,
  LoadingIndicatorModule,
  TabSelectableModule,
  TemplateVariablesModule,
  TooltipModule,
  icoAcademicMulti,
  icoDeleteDuo,
  icoOrganization,
  icoOrganizationDuo,
  icoSignOut,
  icoStudent,
  icoStudentDuo,
  icoTeacher,
  icoTeacherDuo,
  icoTickCircleDuo
} from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { HeaderModule } from '../header/header.module';
import { AcademicHeaderComponent } from './academic-header/academic-header.component';
import { AcademicRegistrationComponent } from './academic-registration/academic-registration.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { IpRangeComponent } from './ip-range/ip-range.component';
import { StudentDetailsComponent } from './student-details/student-details.component';
import { TeacherToggleComponent } from './teacher-toggle/teacher-toggle.component';
import { TermsNoteComponent } from './terms-note/terms-note.component';
import { VerifyAcademicEmailComponent } from './verify-academic-email/verify-academic-email.component';
import { VerifyEmployeeComponent } from './verify-employee/verify-employee.component';

@NgModule({
  declarations: [
    AcademicHeaderComponent,
    AcademicRegistrationComponent,
    IpRangeComponent,
    StudentDetailsComponent,
    TeacherToggleComponent,
    TermsNoteComponent,
    VerifyAcademicEmailComponent,
    VerifyEmployeeComponent,
    ConfirmationComponent
  ],
  imports: [
    AccountUiModule,
    ButtonModule,
    CommonModule,
    CollapseModule,
    FormsModule,
    FileSelectModule,
    HeaderModule,
    IconsModule.withIcons(
      icoDeleteDuo,
      icoSignOut,
      icoStudent,
      icoStudentDuo,
      icoTeacher,
      icoTeacherDuo,
      icoOrganization,
      icoOrganizationDuo,
      icoTickCircleDuo,
      icoAcademicMulti
    ),
    LinkModule,
    LoadingIndicatorModule,
    MarketplaceProductModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TooltipModule,
    TabSelectableModule,
    TemplateVariablesModule
  ],
  exports: [AcademicHeaderComponent, AcademicRegistrationComponent, IpRangeComponent, StudentDetailsComponent, TeacherToggleComponent, VerifyEmployeeComponent]
})
export class AcademicRegistrationModule {}
